
<span>
  <button
    [type]="type"
    class="btn"
    [ngClass]="className"
    [style]="style"
    (click)="onClickbutton($event)"
    [disabled]="isDisabled"
    [id]="id"
  >
    <i [ngClass]="[iconClass ? iconClass : '']" [class]="iconName" aria-hidden="true"></i
    >{{ label }}
  </button>
</span>
